import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Star, Video, CheckCircle2, Users } from "lucide-react";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function AvaliacoesPlataforma() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/avaliacoes-plataforma")
      .then((r) => setData(r.data))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-6" data-testid="avaliacoes-plataforma-page">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-aj-orange">Inteligência</div>
        <h1 className="font-display font-extrabold text-3xl text-aj-blue-deep mt-1">Avaliações da Rede</h1>
        <p className="text-sm text-aj-text-muted mt-1 max-w-2xl">
          Avaliação trimestral dos montadores sobre a plataforma, com vídeos depoimento de 60s.
          Vídeos autorizados podem ser usados em divulgação.
        </p>
      </div>

      {data && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Kpi icon={<Star size={18} />} label="Nota média" v={data.resumo.media ? `${data.resumo.media} ★` : "—"} destaque testid="avp-media" />
          <Kpi icon={<Users size={18} />} label="Avaliações" v={data.resumo.total} testid="avp-total" />
          <Kpi icon={<Video size={18} />} label="Com vídeo" v={data.resumo.com_video} testid="avp-videos" />
          <Kpi icon={<CheckCircle2 size={18} />} label="Uso autorizado" v={data.resumo.autorizados} testid="avp-autorizados" />
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {data?.avaliacoes.length === 0 && (
          <div className="aj-card p-10 text-center text-aj-text-muted md:col-span-2" data-testid="avp-vazio">
            Nenhuma avaliação ainda. Os montadores recebem o pedido a cada 90 dias.
          </div>
        )}
        {data?.avaliacoes.map((a) => (
          <div key={a.id} className="aj-card p-5" data-testid={`avp-card-${a.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-display font-bold text-aj-blue-deep">{a.montador_nome}</div>
                <div className="text-xs text-aj-text-muted">{new Date(a.criado_em).toLocaleDateString("pt-BR")}</div>
              </div>
              <div className="flex gap-0.5 text-[#F59E0B]">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} size={15} fill={n <= a.estrelas ? "currentColor" : "none"}
                    className={n <= a.estrelas ? "" : "text-gray-300"} />
                ))}
              </div>
            </div>
            {a.comentario && <p className="text-sm text-aj-text mt-3">"{a.comentario}"</p>}
            {a.video_path && (
              <div className="mt-3">
                <video controls preload="metadata" className="w-full rounded-lg border border-[#E2E8F0] max-h-56 bg-black"
                  src={`${API_BASE}/api/avaliacoes-plataforma/${a.id}/video`} data-testid={`avp-video-${a.id}`} />
                <div className={`mt-1.5 inline-block px-2 py-0.5 rounded-md text-[10px] font-bold uppercase ${a.autoriza_uso_video ? "bg-aj-success text-white" : "bg-aj-surface-2 text-aj-text-muted"}`}>
                  {a.autoriza_uso_video ? "Uso autorizado para divulgação" : "Uso NÃO autorizado"}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function Kpi({ icon, label, v, destaque, testid }) {
  return (
    <div className={`aj-card p-5 ${destaque ? "border-l-4 border-l-[#FF6700]" : ""}`} data-testid={testid}>
      <div className="flex items-center gap-2 text-aj-orange">{icon}
        <span className="text-[10px] font-bold uppercase tracking-wider text-aj-text-muted">{label}</span>
      </div>
      <div className="font-display font-extrabold text-2xl text-aj-blue-deep mt-2">{v}</div>
    </div>
  );
}
